import { ResourcesConfig } from 'aws-amplify';

export const awsConfig: Record<string, ResourcesConfig> = {
  LOCAL: {
    Auth: {
      Cognito: {
        userPoolClientId: '3bvndiq88c8s0vd1bllemrb7ub',
        userPoolId: 'ap-southeast-1_Crp1wQs78',
        loginWith: {
          username: true,
        },
      },
    },
  },
  DEV: {
    Auth: {
      Cognito: {
        userPoolClientId: '3bvndiq88c8s0vd1bllemrb7ub',
        userPoolId: 'ap-southeast-1_Crp1wQs78',
        loginWith: {
          username: true,
        },
      },
    },
  },
  STAGING: {
    Auth: {
      Cognito: {
        userPoolId: 'ap-southeast-1_Crp1wQs78',
        userPoolClientId: '3bvndiq88c8s0vd1bllemrb7ub',
        loginWith: {
          username: true,
        },
      },
    },
  },
  PROD: {
    Auth: {
      Cognito: {
        userPoolId: 'eu-west-1_aRHZ2ig8l',
        userPoolClientId: '3d189ace6vhmit5loicff4t723',
        loginWith: {
          username: true,
        },
      },
    },
  },
};
